<template>
  <div class="cooperative-enterprise">
     <div class="plate-title">
      <span>我们正在服务的企业</span>
      <p>虽然我们很年轻，但是他们选择给予我们十分的信任。</p>
    </div>
          <!-- 轮播图 -->
      <div class="cooperative-swiper-wrapper">
          <swiper
            v-if="companyImgList.length > 0"
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide
              class="slide-1"
              v-for="(item, index) in companyImgList"
              :key="index"
            >
              <div class="swiper-content">
                <img
                  v-bind:style="{ backgroundImage: 'url(' +'\'' + item +'\'' + ')' }"
                />
              </div>
            </swiper-slide>
          </swiper>
      </div>
    <div class="case-logo-group">

<el-row :gutter="20" class="case-logo-second-group" v-for="(item,index) in companyList" :key="index">
  <el-col :span="4.8" v-for="(item,index) in item" :key="index">
    <!-- <div class="case-logo" v-bind:style="{backgroundImage:'url('+'\'' + item.image +'\'' + ')'}"> -->
    <div class="case-logo">
      <img :src="item.image">
    </div>
  </el-col>
</el-row>
  <div class="auxiliary-line"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import{ Swiper, SwiperSlide } from "vue-awesome-swiper";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name:"adDetails",
  components: {
    
  },
  props: {},
  data() {
    return {
      id: null,
      message: {},
      components:{
        Swiper, 
        SwiperSlide
      },
      picList:[],
     
      companyImgList: [],
      companyList:[],
      height: 0,
      activityIndex: -1,
      swiperLoading: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 1,
        centeredSlides: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        swiperLoading: false,
        on: {
          init() {
            this.setTranslate(0);
          },
          transitionStart() {
            // 开始translate之前触发
            // 如果是第一张
            if (this.activeIndex == 0) {
              this.setTranslate(0); // 因为左边会空出一张图的距离，所以设置位移为0
            }
          },
        },
      },
    };
  },
  watch: {},
  computed: {
    // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    initSwiper(){
      const _this = this;
       new Swiper('.cooperative-swiper-wrapper',{
        swiperOptionTop:this.swiperOptionTop
       })
    },
    // 获取轮播图
    getCompanyImgList(){
    console.log("getAdPosition-Start-year")
    
      const params = {
        positionId:9,
        cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.companyImgList = res.data.adList;
            if(this.companyImgList){
              let companyImgTempList = []
              this.companyImgList.forEach(companyImg=>{
                console.log("companyImgList")
                console.log(companyImg)
                console.log(companyImg.path)
                if(companyImg.path){
                  console.log(handlePicPlusPre(companyImg.path))
                  let paths = handlePicPlusPre(companyImg.path)
                  paths.forEach(path=>{
                    console.log(path)
                    companyImgTempList.push(path);
                  })
                }
              })
              this.companyImgList = companyImgTempList;
            }
          }
        })
    },
    // 获取公司logo
    getCompanyList() {
      let params = {
        position:"2"
      }
      axios
        .get(`/api/company/list`,{
         params
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.companyList = res.data.adList;
            this.companyList = this.handleCompanyList(this.companyList);
            console.log(this.companyList);
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
          this.loading = false;
        });
    },
    // 处理公司列表
    handleCompanyList(companyList){
      console.log("companyList");
      console.log(companyList);
      if(companyList){
        let firstCompanyList = [];
        let secondCompanyList = [];
        for (let index = 0; index < companyList.length; index++) {
          const element = companyList[index];
          if(element.image){
            let imageList = handlePicPlusPre(element.image);
            if(imageList && imageList.length>0){
              element.image = imageList[0];
            }
          }
          secondCompanyList.push(element)
           if((index+1)%5==0 && index != 0 || index == companyList.length - 1){
              firstCompanyList.push(secondCompanyList);
              secondCompanyList = [];
          }
        }
        console.log(firstCompanyList)
        return firstCompanyList;
      }else{
        return [];
      }
    }
  },
  created() {

  },
  mounted() {
    // this.initSwiper()
    this.$nextTick(()=>{
      this.initSwiper()
    })
    this.getCompanyList();
    this.getCompanyImgList();
  }
};
</script>
<style scoped>
.cooperative-enterprise{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin:  40px 0px;
}
.cooperative-enterprise .plate-title{
      min-height: 160px;
}
.cooperative-enterprise .plate-title span{
    font-family: PingFangSC-Regular;
    font-size: 38px;
    color: #201f1f;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
}
.cooperative-enterprise .plate-title p{
    font-size: 18px;
    color: #959595;
    text-align: center;
    line-height: 28px;
    height: 30px;
    margin-top: 10px;
}
.cooperative-enterprise .case-logo-group{
  width: 1060px;
  /* border:1px solid #fff; */
  position: relative;
  
}
.cooperative-enterprise .auxiliary-line{
  width: 100%;
  height: 100%;
  border:1px solid #fff;
  position: absolute;
  top:0px;
  z-index: 2;
}
.cooperative-enterprise .case-logo-second-group{
  width: 80%;
  left: 10%;
  position: relative;
  display: flex;
  flex-direction: row;
  /* align-items: center;
  align-content: center;
  justify-items: center; */
  justify-content: center;
}
.cooperative-enterprise .case-logo{
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    height: 107px;
    width: 192px; 
    padding:10px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    filter:grayscale(90%);
    opacity: 0.7;
}
.cooperative-enterprise .case-logo img{
    height: 107px;
    width: 192px; 
}
.case-logo:hover{
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    overflow: hidden;
    height: 127px;
    width: 212px;
    overflow: hidden;
    background-size: 95%;
    background-repeat: no-repeat;
    background-position: 50%;
    filter:grayscale(0%);
    opacity: 1;
}
.case-logo-group .el-col{
 /* margin: 10px; */
    height: 127px;
    width: 212px;
}
.cooperative-enterprise .show-all{
    text-align: center;
    width: 100%;
    padding: 40px 0;
}
.cooperative-enterprise .show-all span{
    background: #f2f2f2;
    border-radius: 6px;
    font-size: 16px;
    color: #222;
    padding: 12px 118px;
    cursor: pointer;
}
.cooperative-swiper-wrapper {
  min-width: 600px;
  width: 100%;
}
.cooperative-swiper-wrapper .swiper-container {
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff; */
}

.cooperative-swiper-wrapper .swiper-content img {
  height: 100%;
  width: 100%;
  margin: 0;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}
.cooperative-swiper-wrapper .swiper-slide {
  width: 632px !important;
  height: 430px;
}
.cooperative-swiper-wrapper .swiper-content {
  width: 632px;
  height: 430px;
  margin: 0px !important;
}
.sendCode{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 5px;
  border: #cccccc 1px solid;
  background: transparent;
  border-radius: 6px;
}
.sendCode >>> .el-input__inner {
    border: none; 
    border-color: transparent ;
    background: fixed;
    width: 150px!important;
    color:#359FF8;
    margin-top: 0px!important;
}
.sendCode span{
    flex-shrink: 0;
    display: inline-block;
    font-size: 14px;
    text-align: center;
    color: #359FF8;
    cursor: pointer;
    width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/annualMeeting/cooperativeEnterprise.vue